module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"uso":"Uso","ubicacion":"Ubicación de la partición vertical","tipo_soporte":"Tipo de soporte","modalidad_soporte":"Modalidad del soporte","cara_opuesta":"Revestimiento cara Opuesta","necesidad_higiene":"Necesidades especiales de higiene"}}')
  delete Component.options._Ctor
}
